import { FunctionComponent } from 'preact';
import { useCallback } from 'preact/hooks';

import {
  IconButton,
  IconButtonProps,
} from '../../components/IconButton/IconButton';
import { useViewportType } from '../../hooks/useViewportType';
import { useTpaasTracker } from '../../hooks/useTpaasTracker';
import { useIcons } from '../../hooks/useIcons';

export const ReplayButton: FunctionComponent<
  IconButtonProps & {
    handleReplay?: () => void;
  }
> = ({ handleReplay, ...props }) => {
  const { trackEngagementUIElement } = useTpaasTracker();
  const { isMobile } = useViewportType();

  const handleReplayClick = useCallback(
    (e: MouseEvent) => {
      if (e.currentTarget instanceof Element) {
        trackEngagementUIElement({
          elementName: 'Replay',
          elementText: e.currentTarget.textContent ?? undefined,
          elementType: e.currentTarget.tagName.toLowerCase(),
          name: 'Replay',
          playEntry: 'Replay',
        });
      }
      handleReplay?.();
    },
    [handleReplay, trackEngagementUIElement]
  );

  const { Replay } = useIcons();
  return (
    <IconButton
      size={isMobile ? 'medium' : 'large'}
      onClick={handleReplayClick}
      {...props}
      color="secondary"
    >
      <Replay />
    </IconButton>
  );
};
